import React from 'react';
import { useTranslation } from 'react-i18next';
import { DurationTicker } from 'components/DurationTicker';
import { SETUP_ELAPSED_DURATION_TICKER_PROPS } from 'lib/utils/setupDurationDisplay';
import { SetupElapsedMetaRow } from './styled';

const FAISetupElapsedRow = ({
  showSetupLine,
  adjustedSetupStartDate,
  isPaused,
  latestSetupActivity,
  setupExpectedDisplay,
}) => {
  const { t } = useTranslation();
  if (!showSetupLine) return null;
  return (
    <SetupElapsedMetaRow>
      <span>{t('fai.currentSetupPrefix')}</span>
      {adjustedSetupStartDate ? (
        <DurationTicker
          startDate={adjustedSetupStartDate}
          endDateOverride={isPaused ? latestSetupActivity?.end : null}
          {...SETUP_ELAPSED_DURATION_TICKER_PROPS}
        />
      ) : (
        <span>—</span>
      )}
      <span>/</span>
      <span>{setupExpectedDisplay || '—'}</span>
    </SetupElapsedMetaRow>
  );
};

export { FAISetupElapsedRow };
